<template>
  <div v-if="loadingPag" class="carregando" id="padrao">Carregando os
    dados...
  </div>
  <div id="padrao" class="base-geral-telao" v-else>
    <div class="header-telao">
      <div class="container-base-header">
        <span class="info-telao-header numero-lote-telao">Lote <strong>{{ lote.nu }}</strong></span>
        <span class="base-status-cronometro">
        <span class="info-telao-header status-telao"
              :style="[statusLote.statusLoteBg ? {'background-color': statusLote.statusLoteBg} : '']"
        >{{ statusLote.statuslote }}</span>
        <span class="info-telao-header hora-telao">{{ tempo_restante || '--:--' }}</span>
      </span>
      </div>
    </div>
    <div class="container">
      <div class="titulo">
        <div id="lote_telao_titulo">{{ lote.nm_titulo || 'Carregando...' }}</div>
        <div class="vl-avaliacao_label">
          <span class="span_descricao_valores">Avaliação</span>
          <span class="status_descricao">{{ formatarReal(lote.vl_lanceminimo) }}</span>
        </div>
        <div class="vl-lanceinicial_label">
          <span class="span_descricao_valores">Lance mínimo</span>
          <span class="status_descricao">{{ formatarReal(lote.vl_lanceinicial) }}</span>
        </div>
        <div class="lance_info" id="lote_telao_lance_info">
          <span class="campo_valor">
            <span class="vl-atual-apelido">
              <span class="span_descricao_valores"
                    id="lote_telao_apelido">
                {{ lanceAtual.nm_apelido ? lanceAtual.nm_apelido : 'Lance atual' }}
              </span>
              <span class="status_descricao">{{ (formatarReal(lanceAtual.vl_lance) || 'Carregando...') }}</span>
            </span>
            <span class="forma-pgto-label">
              <span v-if="lanceAtual.vl_lance > 0 && lanceAtual.nu_parcelas" class="span_descricao_valores">
                Forma Pgto.
              </span>
              <span class="status_descricao" v-show="lanceAtual.vl_lance > 0">
                {{ lanceAtual.nu_parcelas !== 1 ? lanceAtual.nu_parcelas + 'x' : 'à vista' }}
              </span>
            </span>
          </span>
        </div>
      </div>
      <section class="section_infos">
        <div id="fotos_produto" class="fotos_uno">
          <div class="scrollable_foto_admin_dual" style="display: flex !important;">
            <div class="foto" v-if="lote.fotos" v-for="(foto) in lote.fotos">
              <div id="item_foto_admin" class="item_foto_admin">
                <img class="img_capa" :src="foto.nm_path_completo" width="474" height="364" border="0"/>
              </div>
            </div>
            <div class="foto" v-if="!lote.fotos">
              <div id="item_foto_admin" class="item_foto_admin">
                <img
                  width="474" height="364"
                  alt="lote imagem"
                  src="https://906de634c48fb7d34136160b4c353ae4.s3.amazonaws.com/public/fotos/nao-disponivel.jpg"
                />
              </div>
            </div>
          </div>
        </div>

        <div id="historico_lance" class="historico_lote">
          <div id="lance_concorrente_moderador">
            <div class="vl_incremento_telao">Incremento:
              {{ (formatarReal(vl_incremento) || 'Carregando...') }}
            </div>
            <table id="tb_concorrentes_moderador">
              <thead class="thead">
              <tr>
                <td class="cabecalho">N&ordm;</td>
                <td class="cabecalho"><i class="fa fa-legal"></i>Lance</td>
                <td class="cabecalho"><i class="fa fa-money"></i>Forma Pgto.</td>
                <td class="cabecalho"><i class="fa fa-user"></i>Usu&aacute;rio</td>
              </tr>
              </thead>
              <tbody id="telao_lances">
              <tr v-for="(item, index) in historicoLancesTelao" :key="index">
                <th>{{ index + 1 || '' }}</th>
                <th>{{ (formatarReal(item.vl) || '') }}</th>
                <th class="th_formapgto">{{ item.nu_parcelas !== 1 ? item.nu_parcelas + 'x' : 'à vista' }}</th>
                <th class="th_apelido">
                  <span>{{ item.nm_apelido || '' }}</span>
                </th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <div class="descricao_lote" :style="{'height': (lotesRetirados.length === 0 && lotesRepasse.length === 0) ? '320px !important'
      : ((lotesRetirados.length > 0 && lotesRepasse.length === 0) || lotesRetirados.length === 0 && lotesRepasse.length > 0) ? '240px !important' : '150px !important'}">
        <strong ref="descricao" v-if="!lote.nm_descricao" class="strong_descricao">Descrição </strong>
        <span class="decricao_texto" v-else v-html="lote.nm_descricao"></span>
      </div>
      <div class="corpo_historicos">
        <div class="historico_lote_cancelados_padrao_judicial" v-if="lotesRetirados.length > 0">
          <div>
            <p class="titulo_retirado">
              <strong class="strong-base strong-retidado">Retirados</strong>
              <span><strong class="strong-base strong-cancelado">Cancelados</strong></span>
              <span><strong class="strong-base strong-excluido">Excluídos</strong></span>
            </p>
          </div>
          <marquee>
            <div>
              <template>
                <div>
                  <template v-for="(item) in lotesRetirados">
                    <div
                      :class="(item.statuslote_id === 15) ? 'rotulos_excluidos' : (item.statuslote_id === 13) ?  'rotulos_cancelados' : 'rotulos_retirados'">
                      <p>{{ (item.nu || 'Carregando...') }}</p>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </marquee>
        </div>

        <div v-if="lotesRepasse.length > 0">
          <p class="titulo_retirado">
            <strong class="strong-base strong-retidado repasse_tag">Repasses</strong>
            <span><strong class="strong-base repasse_tag repasse_lance">Repasses com lances</strong></span>
          </p>
        </div>
        <div class="historico_lote_repasse_padrao_judicial" v-if="lotesRepasse.length > 0">
          <marquee>
            <div>
              <template v-for="(item) in lotesRepasse">
                <div :class="(item.statuslote_id === 11) ? 'rotulosxlance' : 'rotulosx'">
                  <p>{{ (item.nu || 'Carregando...') }}</p>
                </div>
              </template>
            </div>
          </marquee>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {parseServerWallClock} from '../services/clock';

export default {
  props: ["dadosLeilao", "dadosModeradorId"],
  data() {
    return {
      leilaoId: this.$route.params.id,
      leilao: [],
      lotes: [],
      saladisputa: null,
      lotesGerais: [],
      dt_postgres: "",
      tempo_restante: "",
      lote: "",
      textoLimpo: "",
      totais_status: "",
      lotesRetirados: [],
      lotesRepasse: [],
      qtd_lote: "",
      historicoLancesTelao: [],
      slides: [],
      statusLote: {
        statuslote: "status",
        statusLoteBg: "",
        statuslote_id: -1,
        statusliberacaolote_id: ""
      },
      lanceAtual: {
        vl_lance: 0.0,
        nm_apelido: null,
        vl_lance_sugerido: 0.0,
        nu_parcelas: 1
      },
      refLanceAtual: null,
      refLanceAtualQuery: null,
      lanceAtualLoteId: null,
      fechamento: false,
      dt_fechamento_lote: 0,
      lote_id: null,
      time: null,
      lances: [],
      loadingPag: true,
      loteAtualModerador: '',
      vl_incremento: 0,
      refStatusLote: null,
      refIncremento: null,
      refDtFechamentoModerador: null,
      scrollTimeoutId: null,
      unwatchClock: null,
    }
  },
  methods: {
    chamadaBanco() {
      return this.firebase_db;
    },

    moderadorLote: async function () {
      try {
        var self = this;
        const db = this.chamadaBanco();
        var loteRef;

        if (this.refDtFechamentoModerador != null) {
          this.refDtFechamentoModerador.off();
        }

        this.refDtFechamentoModerador = db.ref(`/dtfechamento/${this.leilaoId}/${self.loteAtualModerador}`);
        this.refDtFechamentoModerador.on(
          "value",
          function (data) {
            if (data.val()) {
              self.fechamento = data.val();
              self.dt_fechamento_lote = self.fechamento.dt_fechamento;
            } else {
              self.dt_fechamento_lote = null;
            }
          }
        )

        if (self.loteAtualModerador !== "") {
          loteRef = db.ref(`/lote/${this.leilaoId}/${self.loteAtualModerador}`);
        }

        const snapshot = await loteRef.once("value");
        self.lote = snapshot.val();

        await self.acompanhaStatus()
        await self.refreshDadosGerais()
        if (self.lote.nu) {
          self.loadingPag = false;
        }
      } catch (error) {
        console.error('Erro ao obter dados do moderador do lote:', error);
      }
    },

    refreshDadosGerais: async function () {
      const hostName = location.protocol + "//" + window.HOSTNAME;
      var self = this;
      const headers = {
        'Content-Type': 'application/json' // Inclua outros headers necessários
      };

      const token = window.localStorage.getItem('token');
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      fetch(`${hostName}/leilao/get-dados-header-disputa?leilao_id=${this.leilaoId}&lote_id=${this.loteAtualModerador}`, {
        headers: headers
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then(res => {
          self.lotesGerais = res.navegacao.lotes_gerais
          if (self.lotesGerais) {
            self.acompanhaRepasse()
            self.acompanhaRetirado()
          }
        });
    },

    acompanhaStatus: async function () {
      var self = this;

      if (this.refStatusLote != null) {
        this.refStatusLote.off();
      }

      this.refStatusLote = this.firebase_db.ref(`/status/${this.leilaoId}/${self.loteAtualModerador}`);
      this.refStatusLote.on("value", function (data) {
          const status = data.val();

          if (!status) {
            return;
          }

          self.statusLote.statuslote = status.statuslote;
          self.statusLote.statusLoteBg = status.statusLoteBg;
          self.statusLote.statuslote_id = status.statuslote_id;
          self.statusLote.statusliberacaolote_id = status.statusliberacaolote_id;
          if (self.lote && typeof self.lote === 'object') {
            self.$set(self.lote, 'statuslote', status.statuslote);
            self.$set(self.lote, 'statusLoteBg', status.statusLoteBg);
            self.$set(self.lote, 'statuslote_id', status.statuslote_id);
            self.$set(self.lote, 'statusliberacaolote_id', status.statusliberacaolote_id);
          }
          self.liberacao_lote = true;
          if (self.statusLote.statusliberacaolote_id != undefined) {
            if (self.statusLote.statusliberacaolote_id != 2) {
              self.liberacao_lote = false;
            }
          }
        });
    },

    acompanhaLanceAtual: async function () {
      var self = this;

      if (this.refLanceAtualQuery != null) {
        this.refLanceAtualQuery.off();
        this.refLanceAtualQuery = null;
      }

      if (this.lanceAtualLoteId !== self.loteAtualModerador) {
        self.lanceAtual.vl_lance = 0.0;
        self.lanceAtual.nm_apelido = 'Lance atual';
        self.lanceAtual.nu_parcelas = 1;
        this.lanceAtualLoteId = self.loteAtualModerador;
      }

      this.refLanceAtualQuery = this.firebase_db.ref(`/lance/${this.leilaoId}/${self.loteAtualModerador}`)
        .orderByChild("id")
        .limitToLast(1);
      this.refLanceAtual = this.refLanceAtualQuery;
      this.refLanceAtualQuery.on("child_added", function (data) {
          self.lanceAtual.vl_lance = data.val().vl;
          self.lanceAtual.nm_apelido = data.val().nm_apelido;
          self.lanceAtual.nu_parcelas = data.val().nu_parcelas;
        });
    },

    acompanhaRepasse() {
      var self = this;
      self.lotesRepasse = [];

      for (let i in self.lotesGerais) {
        let statusLoteId = self.lotesGerais[i].statuslote_id;
        if (statusLoteId === 11 || statusLoteId === 6) {
          let loteRepasse = {...self.lotesGerais[i], statuslote_id: statusLoteId};
          self.lotesRepasse.push(loteRepasse);
        }
      }
    },

    acompanhaRetirado() {
      const self = this;
      this.lotesRetirados = [];

      for (let i in this.lotesGerais) {
        let statusLoteId = self.lotesGerais[i].statuslote_id;
        if (statusLoteId === 15 || statusLoteId === 13 || statusLoteId === 10) {
          let loteRetirado = {...this.lotesGerais[i], statuslote_id: statusLoteId};
          this.lotesRetirados.push(loteRetirado);
        }
      }
    },

    clock_countdown: async function () {
      if (this.leilao.bn_fechamentoautomatico) {
        this.tempo_restante = "F/Automático";
        return;
      }

      const hora_servidor = this.$clock ? this.$clock.now : 0;

      if (!hora_servidor) {
        this.tempo_restante = "carregando...";
        return;
      }

      const fechamento_lote = parseServerWallClock(this.dt_fechamento_lote);

      if (!fechamento_lote) {
        this.tempo_restante = "";
        return;
      }

      let remainingSeconds = Math.max(0, fechamento_lote - hora_servidor);

      if (remainingSeconds > 0) {
        const {days, hours, minutes, seconds} = this.calculateTime(remainingSeconds);

        if (days >= 2) {
          this.tempo_restante = `${this.formatTime(days)}dias ${this.formatTime(hours)}h ${this.formatTime(minutes)}m`;
        } else if (days >= 1) {
          this.tempo_restante = `${this.formatTime(days)}dia ${this.formatTime(hours)}h ${this.formatTime(minutes)}m`;
        } else {
          this.tempo_restante = `${this.formatTime(hours)}:${this.formatTime(minutes)}:${this.formatTime(seconds)}`;
        }
      } else {
        this.tempo_restante = "";
      }
    },

    calculateTime: function (remainingSeconds) {
      const remainingDays = Math.floor(remainingSeconds / 86400);
      remainingSeconds -= remainingDays * 86400;

      const remainingHours = Math.floor(remainingSeconds / 3600);
      remainingSeconds -= remainingHours * 3600;

      const remainingMinutes = Math.floor(remainingSeconds / 60);
      remainingSeconds -= remainingMinutes * 60;

      return {days: remainingDays, hours: remainingHours, minutes: remainingMinutes, seconds: remainingSeconds};
    },

    formatTime: function (time) {
      return time <= 9 ? "0" + time : time;
    },

    scrollable: async function (contador = 0) {
      const container_fotos = document.querySelector('.scrollable_foto_admin_dual');
      const fotos = document.querySelectorAll('.foto');

      if (fotos.length > 1) {
        const primeiraFoto = fotos[0];
        primeiraFoto.remove();
        container_fotos.appendChild(primeiraFoto);
      }

      this.scrollTimeoutId = setTimeout(() => {
        this.scrollable(contador);
      }, 2000);
    },

    formatarReal(valor) {
      if (this.lote) {
        let val = (valor / 1).toFixed(2).replace('.', ',')
        return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      }
      return
    },

    acompanhaIncremento() {
      // firebase
      var db = this.firebase_db;
      var self = this;

      if (this.refIncremento != null) {
        this.refIncremento.off();
      }

      this.refIncremento = db.ref(
        `/incremento/${this.leilaoId}/${self.loteAtualModerador}`
      );
      this.refIncremento.on("value", function (data) {
        if (data.val()) {
          self.vl_incremento = data.val().raw_incremento;
        }
      });
    },
  },

  created() {
    this.leilao = this.dadosLeilao
    this.saladisputa = new window.saladisputa(this);
    this.saladisputa.acampanharLancesTelao(this.leilaoId, this.loteAtualModerador)


    this.$on('lances', function (data) {
      this.saladisputa.acampanharLancesTelao(this.leilaoId, this.loteAtualModerador);

      if (this.lances) {
        this.historicoLancesTelao = Object.values(this.lances).sort((a, b) => {
          const valorA = parseFloat(a.vl);
          const valorB = parseFloat(b.vl);

          // Ordenar por valor descendentemente
          if (valorA !== valorB) {
            return valorB - valorA;
          }

          // Se os valores forem iguais, colocar à vista primeiro e ordenar parcelado de menor para maior
          if (a.nu_parcelas === 1 && b.nu_parcelas !== 1) {
            return -1; // 'a' é à vista, coloque antes de 'b'
          } else if (a.nu_parcelas !== 1 && b.nu_parcelas === 1) {
            return 1; // 'b' é à vista, coloque depois de 'a'
          } else {
            // Ambos são à vista ou ambos são parcelados, ordenar por número de parcelas crescentemente
            return parseFloat(a.nu_parcelas) - parseFloat(b.nu_parcelas);
          }
        });
      } else {
        this.historicoLancesTelao = [];
      }
    });

    this.unwatchClock = this.$watch(
      () => this.$clock.now,
      () => {
        this.clock_countdown()
      },
      {immediate: true}
    )
    this.scrollable()
  },
  beforeDestroy() {
    if (this.unwatchClock) {
      this.unwatchClock()
      this.unwatchClock = null
    }

    if (this.refDtFechamentoModerador) {
      this.refDtFechamentoModerador.off()
      this.refDtFechamentoModerador = null
    }

    if (this.refStatusLote) {
      this.refStatusLote.off()
      this.refStatusLote = null
    }

    if (this.refLanceAtualQuery) {
      this.refLanceAtualQuery.off()
      this.refLanceAtualQuery = null
      this.refLanceAtual = null
    }

    if (this.refIncremento) {
      this.refIncremento.off()
      this.refIncremento = null
    }

    if (this.scrollTimeoutId) {
      clearTimeout(this.scrollTimeoutId)
      this.scrollTimeoutId = null
    }
  },
  watch: {
    'dadosLeilao'(novo, ant) {
      this.leilao = this.dadosLeilao
    },
    'statusLote.statuslote'(novo, antigo) {
      this.moderadorLote()
      this.acompanhaRepasse()
      this.acompanhaRetirado()
    },
    'lote.dt_fechamento'(novo, antigo) {
      this.clock_countdown()
    },
    'dt_fechamento_lote'(novo, antigo) {
      this.clock_countdown()
    },
    'lanceAtual.vl_lance'(novo, antigo) {
      this.moderadorLote()
      this.acompanhaRepasse()
    },
    'dadosModeradorId'(novo, antigo) {
      this.loteAtualModerador = novo.items[0].statuslotemoderador_id
      this.moderadorLote()
      this.acompanhaStatus()
      this.acompanhaLanceAtual()
      this.acompanhaIncremento()
      this.acompanhaRepasse()
      this.acompanhaRetirado()
    }
  }
}
</script>

<style scoped>
#header, #footer {
  display: none !important;
}

::-webkit-scrollbar {
  display: none !important;
}
</style>

<style>
:root {
  --bg-base-header: #032c35;
  --color-branco: #fff;
}

.cabecalho i {
  margin-right: 5px;
}

span#lote_telao_apelido,
.status_descricao {
  width: fit-content;
  font-size: 1.4em;
}

.forma-pgto-label {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.span_descricao_valores {
  float: left;
  min-height: 30px;
  font-size: 1.4em;
  font-weight: bold;
  font-family: Arial, sans-serif;
  color: #666;
}

span.base_descricao_valores {
  display: flex;
  flex-wrap: wrap;
}

strong.strong_descricao {
  display: block;
  color: var(--bg-base-header);
  margin-top: -10px;
  border-radius: 0 0 12px 12px;
  margin-bottom: 10px;
}

div#lote_telao_titulo {
  font-size: 24px;
  font-weight: 700;
  color: var(--bg-base-header);
  width: 50%;
  display: flex;
  align-items: center;
}

#telao_lances th {
  color: var(--bg-base-header) !important;
  font-size: 18px;
}

.vl_incremento_telao {
  margin: 10px 0px 15px;
  color: rgb(255 80 0);
  font-size: 18px;
  font-weight: bold;
  border: 1px solid;
  text-align: center;
  border-radius: 24px;
}

.titulo {
  height: 90px;
  background: #f6f6f6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 0 12px 12px;
  padding: 15px;
}

span.vl-atual-apelido {
  display: flex;
  flex-direction: column;
}


span.campo_valor {
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 20px;
}

.status_descricao {
  color: var(--bg-base-header) !important;
  font-size: 1.4em;
  font-weight: bold;
  line-height: 40px;
}

.carregando {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: var(--bg-base-header);
  left: 0;
}

div#padrao {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100vw;
  z-index: 999999999999999;
  background: #fff;
  position: fixed;
  top: 0;
}

#padrao .container {
  max-width: 1370px;
}

strong.strong-base {
  color: #fff !important;
  padding: 5px 20px;
  border-radius: 0 50px 0 0;
}

strong.strong-base.strong-excluido {
  background: rgb(0, 102, 114);
}

strong.strong-base.strong-cancelado {
  background: orange;
}

strong.strong-base.strong-retidado {
  background: #e36159;
}

.header-telao {
  margin: auto;
  width: 100%;
  height: 90px;
  color: #fff;
  font-weight: 700;
  background-color: var(--bg-base-header);
  display: flex;
  justify-content: space-between;
}

.base-geral-telao {
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
  position: fixed;
  left: 0;
}

.container-base-header {
  margin: auto;
  max-width: 1170px;
  width: 100%;
  display: flex;
  height: 100%;
  justify-content: space-between;
  align-items: center;
}

span.base-status-cronometro {
  width: 50%;
  display: contents;
}

span.info-telao-header {
  font-size: 24px;
}

span.info-telao-header.status-telao {
  padding: 27px;
  overflow: hidden;
  width: 274px;
  text-align: center;
  background: rgb(89, 133, 220);
  border-radius: 57px 57px 0 0;
  font-size: 1.4em;
}

span.info-telao-header.numero-lote-telao, span.info-telao-header.hora-telao {
  font-size: 48px;
}

.tempo_inativo {
  height: 21px !important;
}

div.historico_lote {
  background: #FFF !important;
}

div.container div.corpo div.titulo {
  margin: -15px 0 0 0px !important;
  width: 100% !important;
  display: flex;
  font: bold 30px "Arial";
  color: #666;
  background: none;
  justify-content: space-between;
  align-items: center;
}

.corpo_historicos {
  height: 35vh;
  margin-top: 1.5rem;
  width: 100%;
}

div.container div.corpo {
  width: 70% !important;
  display: flex;
  height: 520px;
  margin: 0 auto !important;
  background: none;
  flex-wrap: wrap;
  justify-content: space-between;
}

div.container div.corpo div.lance_info {
  margin: 0px !important;
}

div.container div.header div.status {
  margin: 0px !important;
  float: left;
  width: 360px;
  height: 60px;
  margin: 0px;
  -webkit-border-top-left-radius: 50px;
  -webkit-border-top-right-radius: 50px;
  -moz-border-radius-topleft: 50px;
  -moz-border-radius-topright: 50px;
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  background-color: #00cb00;
}

div.container div.header div.lote {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  float: left;
  width: 70%;
  margin: auto;
  height: 100%;
  background: none;
}

div.container div.corpo div.historico_lote {
  float: left;
  max-width: 490px;
  width: 100%;
  height: 356px;
  margin: 0px;
  border: 1px solid #c9c9c9;
  font: bold 20px "Verdana";
  color: #000;
  text-align: center;
  box-shadow: -4px -4px 16px 0px #79797924;
  border-radius: 12px;
  background: none;
  overflow: hidden;
}

div.container div.header {
  width: 100% !important;
}

.header {
  background: #032c35 !important;
  height: 120px;
  display: flex;
  width: 100%;
}

.retirada {
  height: 30px !important;
}

div.historico_lote {
  width: auto;
}

#lance_concorrente_moderador {
  max-height: 340px;
  max-width: 600px;
  width: 600px;
  overflow: auto;
  -webkit-box-shadow: 1px 5px 8px #0000007d;
  box-shadow: 1px 5px 8px #0000007d;
  float: left;
  padding: 10px;
  border-radius: 12px
}

table#tb_concorrentes_moderador {
  width: 100%;
}

.thead {
  width: 100%;
  background: #032c35;
  color: #fff;
  height: 30px;
}

td.cabecalho {
  padding: 5px;
}

tbody#telao_lances {
  background: #cbcbcb2e;
}

p.titulox {
  float: left;
  width: 100%;
  font: bold 20px "Verdana";
  color: #006672;
  text-align: left;
  margin: 0 0 0 5px;
  border-bottom: 1px solid #ccc;
}

p.titulo_retirado {
  float: left;
  width: 100%;
  font: bold 20px "Verdana";
  text-align: left;
  margin: 0 0 0 5px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 1px;
}

div.rotulosx,
div.rotulosxlance,
div.rotulos_cancelados,
div.rotulos_excluidos,
div.rotulos_retirados {
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  float: left;
  width: 70px;
  height: 70px;
  border: 2px solid rgb(11, 78, 40);
  margin: 5px;
  background-color: rgba(11, 78, 40, 0.44);
}

div.rotulosx p,
div.rotulosxlance p,
div.rotulos_retirados p,
div.rotulos_excluidos p,
div.rotulos_cancelados p {
  margin: 12px 0 0 0;
  font-size: 20px;
  text-align: center;
  color: #000000 !important;
  font-weight: bolder;
}

div.rotulosxlance {
  border: 2px solid rgb(3, 69, 117);
  background-color: rgba(3, 69, 117, 0.48);
}

div.rotulos_cancelados {
  border: 2px solid darkorange;
  background-color: #F3BC8F;
}

div.rotulos_excluidos {
  border: 2px solid #006671;
  background-color: rgba(0, 102, 113, 0.2);
}

div.rotulos_retirados {
  border: 2px solid red;
  background-color: #f38f8f;
}

.img_capa {
  border-radius: 12px;
  border: 1px solid #cbcbcb2e;
}

.repasse_tag {
  background: #0b4e28 !important;
}

.repasse_lance {
  background: rgb(3, 69, 118) !important;
}

div#lote_telao_titulo {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 450px;
  max-height: 88px;
}

.descricao_lote {
  width: 100%;
  margin: auto !important;
  height: 150px;
  padding: 15px;
  font-size: 16px;
  color: var(--bg-base-header) !important;
  overflow: auto;
  box-shadow: 1px 5px 8px #0000007d;
  border-radius: 12px;
}

.decricao_texto {
  max-height: 300px;
  overflow-y: auto;
}

div.container div.header div.status span {
  margin: 10px 0 0 0 !important;
}

.status_leilao_telao {
  margin-top: -45px;
}

.numero_lote {
  margin: -15px 0 !important;
}

div.container div.corpo div.fotos_uno {
  margin: 0px !important;
  box-shadow: -4px -4px 16px 0px #79797924;
  border-radius: 12px;
}

section.section_infos {
  margin: 10px 0px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.scrollable_foto_admin_dual {
  display: flex;
  overflow: hidden;
  position: relative;
  width: 474px;
  height: 364px;
}

.foto {
  min-width: 100%;
  transition: transform .5s ease;
}

.item_foto_admin {
  border: none !important;
}

#fotos_produto {
  overflow: hidden;
  width: 474px;
  height: 364px;
}

th.th_apelido {
  width: 185px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.th_formapgto {
  width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

span.info-telao-header.hora-telao, span.info-telao-header.numero-lote-telao {
  font-size: 1.5em;
}

.vl-lanceinicial_label,
.vl-avaliacao_label {
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 991px) {
  span#lote_telao_apelido {
    width: 160px !important;
  }

  div.historico_lote {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #lance_concorrente_moderador {
    width: 100%;
  }

  section.section_infos {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
  }

  .descricao_lote {
    margin: 5rem auto !important;
  }

  .container-base-header {
    width: 90% !important;
  }

  div#padrao {
    overflow: auto;
  }

  #telao_lances th {
    font-size: 14px !important;
  }

  div#item_foto_admin img {
    width: 350px !important;
    margin: auto;
    height: 100% !important;
  }

  #fotos_produto {
    overflow: hidden;
    width: 350px !important;
    height: auto !important;
    margin: 2rem auto;
  }

  div#lote_telao_titulo {
    padding: 15px 0px !important;
    width: 100% !important;
  }

  div#lote_telao_lance_info {
    width: 100% !important;
  }

  .status_descricao {
    font-size: 18px !important;
  }

  .titulo {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    height: auto !important;
  }

  span.campo_valor {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
  }

  span.info-telao-header.hora-telao, span.info-telao-header.numero-lote-telao {
    width: 80px;
    text-align: center;
    font-size: 22px !important;
  }

  span.info-telao-header {
    font-size: 14px !important;
  }

  span.info-telao-header.status-telao {
    padding: 15px !important;
    overflow: hidden;
    width: 170px !important;
    text-align: center;
    background: #5985dc;
    border-radius: 40px !important;
  }

  .span_descricao_valores {
    font-size: 18px !important;
  }

  strong.strong-base {
    padding: 5px 15px !important;
  }

  p.titulo_retirado, p.titulox {
    font-size: 15px !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Telao.vue